import { render } from "./AtualizaPerfilUsuario.vue?vue&type=template&id=2a4b9876&scoped=true"
import script from "./AtualizaPerfilUsuario.vue?vue&type=script&lang=js"
export * from "./AtualizaPerfilUsuario.vue?vue&type=script&lang=js"

import "./AtualizaPerfilUsuario.vue?vue&type=style&index=0&id=2a4b9876&scoped=true&lang=css"
import "@vueform/multiselect/themes/default.css?vue&type=style&index=1&lang=css"

import exportComponent from "/opt/vue/ped/ped-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a4b9876"]])

export default __exports__